import script from "./EditLoop.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditLoop.vue?vue&type=script&setup=true&lang=ts"

import "./EditLoop.vue?vue&type=style&index=0&id=23743810&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23743810"]])

export default __exports__